import { usePopperTooltip } from 'react-popper-tooltip'

export const useTooltip = usePopperTooltip
